import { render, staticRenderFns } from "./seekerCollectItem.vue?vue&type=template&id=9a1a0f84&scoped=true"
import script from "./seekerCollectItem.vue?vue&type=script&lang=js"
export * from "./seekerCollectItem.vue?vue&type=script&lang=js"
import style0 from "./seekerCollectItem.vue?vue&type=style&index=0&id=9a1a0f84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1a0f84",
  null
  
)

export default component.exports